import React from "react";
import styled from "styled-components";
import InnerContentWrapper from "../components/styles/InnerContentWrapper";
import useAxios from "axios-hooks";
import { API_URL } from "../config";
import QueryLoading from "../components/animations/QueryLoading";
import { Link, Route, Switch } from "react-router-dom";
import CourseComponent from "../components/coursepage/course/CourseComponent";
import CoursePreview from "../components/coursepage/course/CoursePreview";

const StyledCourseListPage = styled.div`
  h1 {
  }
  hr {
    margin-bottom: 2rem;
  }

  .coursePreview {
    display: grid;
    grid-template-columns: 1fr 2fr auto;
    grid-column-gap: 20px;
    padding: 10px;
    box-shadow: 0px 0px 10px 6px rgba(0, 0, 0, 0.16);
    margin-bottom: 1rem;
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      display: block;
    }
  }
  .courseImage {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .courseSummary {
    .courseTitle {
      font-size: 20px;
    }
  }
  .courseLink {
    width: 125px;
    height: 45px;
    line-height: 43px;
    text-align: center;
    color: ${(props) => props.theme.primaryBlue};
    border: 1px solid ${(props) => props.theme.primaryBlue};
    transition: all 200ms ease-out;
    &:hover {
      color: white;
      background: ${(props) => props.theme.primaryBlue};
    }
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      display: block;
    }
  }
`;

const CourseListPage = ({ userData, userLoading, refetchUser }) => {
  const [{ data: courses, loading: coursesLoading }] = useAxios({
    url: `${API_URL}/getMyCourses`,
    method: "GET",
    withCredentials: true,
  });

  if (userLoading || coursesLoading) return <QueryLoading />;

  return (
    <Switch>
      <Route
        path="/course/:courseId"
        render={(props) => (
          <CourseComponent
            userLoading={userLoading}
            userData={userData}
            refetchUser={refetchUser}
            courses={courses}
            {...props}
          />
        )}
      />
      <Route>
        <StyledCourseListPage>
          <InnerContentWrapper>
            <h1>My Courses</h1>
            <hr />
            <div className="courses">
              {courses.length > 0
                ? courses.map((course) => (
                    <CoursePreview
                      key={course.courseId}
                      courseId={course.courseId}
                      courseImage={course.courseImage}
                      courseTitle={course.courseTitle}
                      courseDescription={course.courseDescription}
                    >
                      <Link
                        to={`/course/${course.courseId}`}
                        className="courseLink"
                      >
                        View Course
                      </Link>
                    </CoursePreview>
                  ))
                : "You don't own any courses"}
            </div>
          </InnerContentWrapper>
        </StyledCourseListPage>
      </Route>
    </Switch>
  );
};

export default CourseListPage;
